import { render, staticRenderFns } from "./KedingTips.vue?vue&type=template&id=3c115e2e&scoped=true"
import script from "./KedingTips.vue?vue&type=script&lang=js"
export * from "./KedingTips.vue?vue&type=script&lang=js"
import style0 from "./KedingTips.vue?vue&type=style&index=0&id=3c115e2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c115e2e",
  null
  
)

export default component.exports